import { Slide } from '@/components/slides/Slide';
import { Slide as SlideData } from '@/types/slide';
import { Box, Chip, List, ListItem, Paper, Skeleton, useTheme } from '@mui/material';
import classes from './SlideThumbnailPanel.module.css';

interface SlideThumbnailPanelProps {
    slides?: SlideData[];
    thumbnailIdx?: number;
    onThumbnailChange?: (pageIdx: number) => void;
}

export const SlideThumbnailPanel: React.FC<SlideThumbnailPanelProps> = ({ slides, thumbnailIdx, onThumbnailChange }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                p: 1,
            }}
            className={classes.panel}
        >
            <List
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'scroll',
                    width: '100%',
                    p: 0,
                }}
            >
                {slides
                    ? slides.map((slide, index) => (
                          <ListItem
                              key={`slide-thumbnail-${index}`}
                              sx={{
                                  p: 1,
                                  height: '100%',
                                  width: 'auto',
                                  backgroundColor: index === thumbnailIdx ? `color-mix(in srgb, ${(theme.vars || theme).palette.primary.main}, transparent 50%)` : 'transparent',
                                  ':hover': {
                                      cursor: index !== thumbnailIdx ? 'pointer' : undefined,
                                      backgroundColor: index !== thumbnailIdx ? (theme.vars || theme).palette.action.selected : undefined,
                                  },
                              }}
                              onClick={() => {
                                  if (onThumbnailChange) {
                                      onThumbnailChange?.(index);
                                  }
                              }}
                          >
                              {/* this extra div is neceesary for some browser like Safari in order to correctly calculated the width for the scrolling area */}
                              <div
                                  style={{
                                      height: '100%',
                                      width: 'auto',
                                      aspectRatio: 4 / 3,
                                  }}
                              >
                                  <Paper
                                      elevation={index !== thumbnailIdx ? 3 : undefined}
                                      sx={{
                                          position: 'relative',
                                          height: '100%',
                                          width: 'auto',
                                          aspectRatio: 4 / 3,
                                      }}
                                  >
                                      <Slide components={slide.data} preview />
                                      <Chip label={index + 1} sx={{ position: 'absolute', top: 8, left: 8, zIndex: 99 }} />
                                  </Paper>
                              </div>
                          </ListItem>
                      ))
                    : Array.from(Array(8)).map((_, index) => (
                          <ListItem
                              key={`slide-thumbnail-${index}`}
                              sx={{
                                  p: 1,
                                  height: '100%',
                                  width: 'auto',
                              }}
                          >
                              <div
                                  style={{
                                      height: '100%',
                                      width: 'auto',
                                      aspectRatio: 4 / 3,
                                  }}
                              >
                                  <Skeleton variant='rounded' sx={(theme) => ({ height: '100%', aspectRatio: 4 / 3, backgroundColor: (theme.vars || theme).palette.grey[300] })} />
                              </div>
                          </ListItem>
                      ))}
            </List>
        </Box>
    );
};
